import React, { memo } from 'react';
import { Price } from '@pegasus/translation';
import { useConfig } from '@browsing/config';
export var FormatPrice = function (_a) {
    var _b;
    var price = _a.price, _c = _a.superscript, superscript = _c === void 0 ? '' : _c, _d = _a.maximumFractionDigits, maximumFractionDigits = _d === void 0 ? 2 : _d;
    var config = useConfig();
    var locale = (_b = config.locale[config.appdomain]) === null || _b === void 0 ? void 0 : _b.replace('_', '-');
    return (React.createElement("span", null,
        React.createElement(Price, { languageCode: locale, cents: price, superscript: superscript, overrideCurrencyFormat: config.overrideCurrencyFormat, maximumFractionDigits: maximumFractionDigits })));
};
FormatPrice.displayName = 'FormatPrice';
export default memo(FormatPrice);
